import * as React from 'react';
import { ICardsChoseQuestionProps } from '../../types';
import * as styles from '../CardsQuestion/styles.css';
import { Card } from '../Card';

export const CardsChoseQuestion: React.FC<React.PropsWithChildren<ICardsChoseQuestionProps>> = props => {
  return (
    <div className={styles['cards']}>
      {props.cards.map(card => (
        <Card
          {...card}
          key={card.value}
          onClick={props.handleSelect}
          iconType={props.iconType}
          selected={props.value && props.value.includes(card.value)}
          selectable
        />
      ))}
    </div>
  );
};

CardsChoseQuestion.displayName = 'CardsChoseQuestion';
